import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useGoCardlessDropin } from '@gocardless/react-dropin'

import { ButtonWithSpinner } from '@reveni-io/reveni-ui'

import { userPermissions } from '@/common/constants'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import * as Styles from './styles'

const SignMandateButton = ({
  onCreatePaymentMethod,
  loading,
  fetchBankAccounts,
  bankAccount,
  paymentMethodCreated,
  setPaymentMethodCreated,
}) => {
  const { t } = useTranslation()
  const { hasPermission } = useUserPermissions()

  const { open, ready, error, exit } = useGoCardlessDropin({
    billingRequestFlowID: bankAccount?.request_id || paymentMethodCreated?.request_id,
    onSuccess: () => {
      fetchBankAccounts()
      setPaymentMethodCreated(null)
      exit()
    },
    onExit: () => {
      fetchBankAccounts()
      setPaymentMethodCreated(null)
      exit()
    },
    environment: import.meta.env.VITE_GOCARDLESS_ENVIRONMENT,
  })

  useEffect(() => {
    if (paymentMethodCreated?.request_id && ready && !error && !paymentMethodCreated?.is_request_fulfilled) {
      open()
    }
  }, [paymentMethodCreated?.is_request_fulfilled, paymentMethodCreated?.request_id, error, open, ready])

  const handleOnClick = async () => {
    if (bankAccount?.request_id) {
      open()
    } else {
      await onCreatePaymentMethod()
    }
  }

  if (!ready || bankAccount?.is_request_fulfilled || !hasPermission(userPermissions.editBillingSettings)) return null

  return (
    <Styles.Container>
      <ButtonWithSpinner
        loading={loading}
        disabled={loading}
        onClick={handleOnClick}
        defaultLabel={t('Firmar mandato')}
        loadingLabel={t('Firmando mandato')}
        size="s"
      />
    </Styles.Container>
  )
}

export default SignMandateButton
